export default __webpack_public_path__ + "static/media/avatar.1196bd88.svg";